<template>
    <div id="header">
        <el-row>
            <el-col :xs="0">
                <div :class="headerClass" :style="headImg==null?{}:{backgroundImage:'url('+headImg+')'}">
                    <el-col :span="24">
                        <el-col :xs="0" :sm="{span: 1}" :md="{span: 3}" :lg="{span: 3}" :xl="{span: 3}">
                            <div class="header-boxs"></div>
                        </el-col>
                        <el-col :xs="0" :sm="{span: 22}" :md="{span: 19}" :lg="{span: 19}" :xl="{span: 19}">
                            <el-menu :default-active="pathName" mode="horizontal" @select="handleSelect"
                                     background-color=rgba(0,0,0,0.2) text-color=#fff
                                     active-text-color=#fff>
                                <el-col :xs="0" :sm="7" :md="7" :lg="7" :xl="10">
                                    <el-menu-item index="/main">
                                        <!--                  <img v-if="screenWidth >=992" src="../../../static/image/main/mainLogo.png" class="header-logo">-->
                                        <!--                  <img v-else src="../../../static/image/main/mainLogoMin.png" class="header-logo-min">-->
                                        <img src="../../../static/image/main/mainLogo.png" class="header-logo">
                                    </el-menu-item>
                                </el-col>
                                <el-submenu index="/enterprise">
                                    <template slot="title">走进索康</template>
                                    <el-menu-item index="en-into-corporate">企业介绍</el-menu-item>
                                    <el-menu-item index="en-corporate-history">企业历史</el-menu-item>
                                    <el-menu-item index="en-corporate-culture">企业文化</el-menu-item>
                                    <el-menu-item index="en-material-history">膨体历史</el-menu-item>
                                    <el-menu-item index="en-production">生产与研发</el-menu-item>
                                </el-submenu>
                                <el-submenu index="/product">
                                    <template slot="title">产品专区</template>
                                    <el-menu-item index="manshu">曼姝</el-menu-item>
                                    <el-menu-item index="lixiu">立秀</el-menu-item>
                                    <el-menu-item index="ainose">AINOSE</el-menu-item>
                                    <el-menu-item index="hetong">郝通</el-menu-item>
                                    <el-menu-item index="meiti">美替</el-menu-item>
                                </el-submenu>
                                <el-submenu index="/honor">
                                    <template slot="title">技术荣誉</template>
                                    <el-menu-item index="honorPatentTechnology">技术 & 专利</el-menu-item>
                                    <el-menu-item index="honorCertificate">专利证书</el-menu-item>
                                    <el-menu-item index="honorQualifications">资质 & 荣誉</el-menu-item>
                                </el-submenu>
<!--                                <el-menu-item index="/case">美例说</el-menu-item>-->
                                <el-submenu index="/security">
                                    <template slot="title">防伪查询</template>
                                    <el-menu-item index="QA">质保卡流程</el-menu-item>
                                    <el-menu-item index="authenticity">真伪查询</el-menu-item>
                                </el-submenu>
                                <el-menu-item index="/contact">联系我们</el-menu-item>
                            </el-menu>
                        </el-col>
                        <el-col :xs="0" :sm="{span: 1}" :md="{span: 2}" :lg="{span: 2}" :xl="{span: 2}">
                            <div class="header-boxs"></div>
                        </el-col>
                    </el-col>
                </div>
            </el-col>

            <el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0" type="flex" justify="center" align="middle">
                <div class="header-box-minT">
                    <el-col :span="16" :offset="4" type="flex" justify="center" align="middle">
                        <div class="header-T">{{headerT}}</div>
                    </el-col>
                    <el-col :span="4" type="flex" justify="center" align="middle">
                        <div class="header-Icon"><i style="font-size: 25px;" class="iconfont icon-danlieliebiao"
                                                    @click="table = true"></i></div>
                    </el-col>
                </div>
            </el-col>
            <!--      <el-drawer :xs="24" :sm="0" :md="0" :lg="0" :xl="0" type="flex" justify="center" align="middle">-->
            <!--          <div>-->
            <!--            <div class="header-box-minB" @touchmove.prevent></div>-->
            <el-drawer :xs="24" :sm="0" :md="0" :lg="0" :xl="0" type="flex" justify="center" align="middle"
                       :visible.sync="table" :show-close="false"
                       direction="rtl"
                       size="60%" @touchmove.prevent>
                <div class="header-box" @touchmove.prevent>
                    <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
                    </el-radio-group>
                    <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @select="handleSelectM"
                             :collapse="isCollapse" :unique-opened="true" text-color=#fff background-color=#410099>
                        <el-menu-item index="/main,索康">
                            <!--                  <img v-if="screenWidth >=992" src="../../../static/image/main/mainLogo.png" class="header-logo">-->
                            <!--                  <img v-else src="../../../static/image/main/mainLogoMin.png" class="header-logo-min">-->
                            <img src="../../../static/image/main/mainLogo.png" class="header-logo">
                        </el-menu-item>
                        <el-submenu index="/enterprise,走进索康">
                            <template slot="title">走进索康</template>
                            <el-menu-item index="en-into-corporate">企业介绍</el-menu-item>
                            <el-menu-item index="en-corporate-history">企业历史</el-menu-item>
                            <el-menu-item index="en-corporate-culture">企业文化</el-menu-item>
                            <el-menu-item index="en-material-history">膨体历史</el-menu-item>
                            <el-menu-item index="en-production">生产与研发</el-menu-item>
                        </el-submenu>
                        <el-submenu index="/product">
                            <template slot="title">产品专区</template>
                            <el-menu-item index="manshu,曼姝">曼姝</el-menu-item>
                            <el-menu-item index="lixiu,立秀">立秀</el-menu-item>
                            <el-menu-item index="ainose,AINOSE">AINOSE</el-menu-item>
                            <el-menu-item index="hetong,郝通">郝通</el-menu-item>
                            <el-menu-item index="meiti,美替">美替</el-menu-item>
                        </el-submenu>
                        <el-submenu index="/honor,技术荣誉">
                            <template slot="title">技术荣誉</template>
                            <el-menu-item index="honorPatentTechnology">技术 & 专利</el-menu-item>
                            <el-menu-item index="honorCertificate">专利证书</el-menu-item>
                            <el-menu-item index="honorQualifications">资质 & 荣誉</el-menu-item>
                        </el-submenu>
<!--                        <el-menu-item index="/case,美例说">美例说</el-menu-item>-->
                        <el-submenu index="/security">
                            <template slot="title">防伪查询</template>
                            <el-menu-item index="QA,质保卡流程">质保卡流程</el-menu-item>
                            <el-menu-item index="authenticity,真伪查询">真伪查询</el-menu-item>
                        </el-submenu>
                        <el-menu-item index="/contact,联系我们">联系我们</el-menu-item>
                    </el-menu>
                </div>
            </el-drawer>
            <!--          </div>-->
            <!--      </el-drawer>-->
        </el-row>
    </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      tabPosition: 'top',
      activeIndex: '1',
      isCollapse: false,
      table: null,
      headerClass: 'header-box',
      headerT: '索康',
      pathName: 'main',
      headImg:null,
      head:null
    }
  },
  computed: {
    key() {
      return this.$route.path
    }
  },
  created() {
    if(sessionStorage.getItem("headerT")){
      this.headerT = sessionStorage.getItem("headerT");
    }

    this.$store.dispatch('main/mainMessage').then((res) => {
      this.head = res
      if (this.$route.path == '/product/lixiu') {
        this.headerClass = 'header-lixiu'
        this.headImg=res.LiXiu.detailBarImage
      } else if (this.$route.path == '/product/manshu') {
        this.headerClass = 'header-manshu'
        this.headImg=res.ManShu.detailBarImage
      } else if (this.$route.path == '/product/hetong') {
        this.headerClass = 'header-hetong'
        this.headImg=res.HaoTong.detailBarImage
      } else if (this.$route.path == '/product/ainose') {
        this.headerClass = 'header-ainose'
        this.headImg=res.AINOSE.detailBarImage
      } else {
        this.headerClass = 'header-box'
        this.headImg=null
      }
    })

    if (this.$route.path == '/product/lixiu') {
      this.headerClass = 'header-lixiu'
    } else if (this.$route.path == '/product/manshu') {
      this.headerClass = 'header-manshu'
    } else if (this.$route.path == '/product/hetong') {
      this.headerClass = 'header-hetong'
    } else if (this.$route.path == '/product/ainose') {
      this.headerClass = 'header-ainose'
    } else {
      this.headerClass = 'header-box'
      this.headImg=null
    }
    // let data = { userId: 1, token: '91c03618-ff5f-4325-9c89-309928cd1eca' }
    // this.$store.dispatch('product/productList', data)
    // console.log(this.$route.path)

  },

  watch: {

    $route(to, from) {
      // console.log( to , from )
      // console.log(to.query.id)
      // console.log(to.path)
      // console.log(this.pathName)
      let path = to.path
      if(to.query.id != undefined){
        this.pathName = to.query.id + ''
      }else {
        let str = to.path+''
        String.prototype.replaceAll = function (FindText, RepText) {
          return this.replace(new RegExp(FindText, "g"), RepText);
        }
        //用法，把所有n替换成w
        let str1= str.replaceAll("/","")
        let num=str.length-str1.length
        // console.log("i出现的次数为："+(str.length-str1.length));//两者之差为i出现次数
        if(num==1){
          this.pathName = to.path + ''
        }else {
          let x=str.indexOf('/');
          for(let i=0;i<1;i++){
            x=str.indexOf('/',x+1);
          }
          let str2 = str.substr(x+1)
          // console.log(str2)
          this.pathName=str2
        }


      }

      //  to , from 分别表示从哪跳转到哪，都是一个对象
      // to.path   ( 表示的是要跳转到的路由的地址 eg:  /home );
      // to.query.id 提取id进行http请求数据更新页面
      if (path == '/information/details') {
        this.headerT = "新闻资讯"
        sessionStorage.setItem("headerT", "新闻资讯");
      }
      if (path == '/product/lixiu') {
        this.headerClass = 'header-lixiu'
        this.headImg=this.head.LiXiu.detailBarImage
      } else if (path == '/product/manshu') {
        this.headerClass = 'header-manshu'
        this.headImg=this.head.ManShu.detailBarImage
      } else if (path == '/product/hetong') {
        this.headerClass = 'header-hetong'
        this.headImg=this.head.HaoTong.detailBarImage
      } else if (path == '/product/ainose') {
        this.headerClass = 'header-ainose'
        this.headImg=this.head.AINOSE.detailBarImage
      } else {
        this.headerClass = 'header-box'
        this.headImg=null
      }
    }
  },
  mounted() {

  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath)
      // console.log(this.$route.path)
      let path = this.$route.path
      if (keyPath.length === 1) {
        this.$router.push({path: key})
        this.headerClass = 'header-box'
      } else {
        if (keyPath[0] === '/product' || keyPath[0] === '/security') {
          // console.log(keyPath[0])
          if (key == 'manshu') {
            this.headerClass = 'header-manshu'
          } else if (key == 'lixiu') {
            this.headerClass = 'header-lixiu'
          } else if (key == 'hetong') {
            this.headerClass = 'header-hetong'
          } else if (key == 'ainose') {
            this.headerClass = 'header-ainose'
          } else {
            this.headerClass = 'header-box'
          }
          this.$router.push({
            path: keyPath[0] + '/' + key
          })
          // console.log(key)
        } else {
          this.headerClass = 'header-box'
          this.$router.push({
            path: keyPath[0],
            query: {
              id: key
            }
          })
          // 判断页面是否相同,并进行跳转锚点
          if (path === keyPath[0]) {
            this.$store.dispatch('method/anchorPoint', key)
          }
        }
      }
    },

    handleSelectM(key, keyPath) {
      // console.log(this.$route.path)
      var key1 = key.split(",")
      // console.log(key.split(","), keyPath)
      let path = this.$route.path
      if (keyPath.length === 1) {
        this.headerT = key1[1]
        sessionStorage.setItem("headerT", key1[1]);
        this.$router.push({path: key1[0]})
        this.headerClass = 'header-box'
      } else {
        if (keyPath[0] === '/product' || keyPath[0] === '/security') {
          // console.log(keyPath[0])
          this.headerT = key1[1]
          sessionStorage.setItem("headerT", key1[1]);
          this.$router.push({
            path: keyPath[0] + '/' + key1[0]
          })
          // console.log(key)
        } else {
          var keyPath1 = keyPath[0].split(",")
          this.headerClass = 'header-box'
          this.headerT = keyPath1[1]
          sessionStorage.setItem("headerT", keyPath1[1]);
          this.$router.push({
            path: keyPath1[0],
            query: {
              id: key
            }
          })
          // 判断页面是否相同,并进行跳转锚点
          if (path === keyPath[0]) {
            this.$store.dispatch('method/anchorPoint', key)
          }
        }
      }
      this.table = false
    }
  }
}
</script>

<style scoped>

</style>

<style>
    @media screen and (max-width: 750px) {
        .header-box-minT {
            background-color: #410099;
            height: 200px;
            color: white;
            font-family: SY-Normal;
        }

        .header-T {
            height: 200px;
            font-size: 60px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .header-Icon {
            height: 200px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .header-box-minB {
            -webkit-transition: width 0.28s;
            transition: width 0.28s;
            height: 100%;
            position: fixed;
            font-size: 0px;
            top: 0;
            bottom: 0;
            left: 0;
            background: #000;
            opacity: 0.4;
            width: 100%;
            height: 100%;
            z-index: 999;
            overflow: hidden;
            position: fixed;
        }

        .header-box-min {
            -webkit-transition: width 0.28s;
            transition: width 0.28s;
            /*background-color: #410099;*/
            background-color: rgba(255, 255, 255, 0.2);
            height: 100%;
            width: 70%;
            position: fixed;
            font-size: 0px;
            top: 0;
            bottom: 0;
            left: 0;
            z-index: 1001;
            overflow: hidden;
            position: fixed;
        }

        .header-logo {
            width: 100%;
        }

        .el-menu {
            border-right: solid 0px #e6e6e6 !important;
        }

        .el-menu > li, .el-submenu__title {
            font-family: SY-Normal;
        }

        .el-drawer__header {
            margin-bottom: 0 !important;
            padding: 0 !important;
        }

        .el-radio-button__inner, .el-radio-group {
            display: flex !important;
            margin-bottom: 0 !important;
        }

        .el-drawer__body {
            background-color: #430098;
            overflow-y: auto;
            /*background-color: rgba(255, 255, 255, 0.2);*/
        }

        .el-menu--inline > .el-menu-item{
            background-color: rgba(65, 0, 56, 0.2) !important;
        }
    }

    @media screen and (min-width: 750px) {
        .el-menu--horizontal > .el-submenu .el-submenu__title {
            height: 77px !important;
            line-height: 77px !important;
        }

        .el-menu--horizontal > .el-menu-item {
            height: 77px !important;
            line-height: 77px !important;
        }

        .el-menu--horizontal > .el-col .el-menu-item {
            height: 77px !important;
            line-height: 77px !important;
        }

        .el-submenu__title {
            padding: 0 19px !important;
            background-color: rgba(0, 0, 0, 0) !important;
        }

        .el-menu-item {
            background-color: rgba(0, 0, 0, 0) !important;
        }

        .header-box {
            background-color: #410099;
            display: flex;
        }

        .header-manshu {
            background-image: url('../../../static/image/product/manshu/manshu.png');
            background-size: 100% 100%;
            display: flex;
        }

        .header-lixiu {
            background-image: url('../../../static/image/product/lixiu/lixiu.png');
            background-size: 100% 100%;
            display: flex;
        }

        .header-hetong {
            background-image: url('../../../static/image/product/hetong/hetong.jpg');
            background-size: 100% 100%;
            display: flex;
        }

        .header-ainose {
            background-image: url('../../../static/image/product/ainose/aiNose.jpg');
            background-size: 100% 100%;
            display: flex;
        }

        .header-boxs {
            width: 100%;
            background-color: rgba(0, 0, 0, 0.2);
            height: 77px
        }

        .el-submenu__title i {
            color: white !important;
        }

        .el-menu > li, .el-submenu__title {
            font-family: SY-Normal;
            font-size: 14px !important;
        }

        .header-logo {
            width: 229px;
        }

        .header-logo-min {
            width: 150px;
        }

        .el-menu {
            border-bottom: solid 0px #e6e6e6 !important;
        }
    }
</style>
